import { render, staticRenderFns } from "./addPlan.vue?vue&type=template&id=24af9266"
import script from "./addPlan.vue?vue&type=script&lang=js"
export * from "./addPlan.vue?vue&type=script&lang=js"
import style0 from "./addPlan.vue?vue&type=style&index=0&id=24af9266&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports